import DOMPurify from 'dompurify';
import {
    REPORT_CONTENT_CLASSNAME,
    REPORT_CONTENT_WRAPPER_CLASSNAME,
} from '@/components/preview/constants';
import { keepOnlyFontSizeStyles } from '@/lib/rich-text';
import { cn } from '@/lib/utils';

interface StandaloneRichTextProps {
    content?: string;
    className?: string;
}

export default function StandaloneRichText({ content, className }: StandaloneRichTextProps) {
    if (!content?.trim()) return null;

    // See EditableSection: legacy checklist markup renders as a plain list.
    const sanitizedContent = keepOnlyFontSizeStyles(
        DOMPurify.sanitize(content, { FORBID_TAGS: ['input'] }),
    );

    return (
        <div className={cn(REPORT_CONTENT_WRAPPER_CLASSNAME, className)}>
            <div
                className={REPORT_CONTENT_CLASSNAME}
                dangerouslySetInnerHTML={{ __html: sanitizedContent }}
            />
        </div>
    );
}
